/*
 * MLKFRTS: drawer Back-button fix (CART-BACK-SCROLL-OCT24).
 * Android Chrome's Back button closes an open modal <dialog> natively (CloseWatcher),
 * which skips <theme-drawer>.close(), so the drawer keeps [open] and html[scroll-lock]
 * stays on and the page can't scroll. Here: when a drawer's dialog closes natively,
 * run the drawer's normal close(); on popstate / bfcache restore, release any
 * scroll lock left behind by a dialog that is no longer open.
 */
import { unlockScroll } from '@theme/utilities';

const panelOf = (drawer) => drawer.querySelector('dialog');

function wire(drawer) {
  if (drawer.__mlkfrtsBack) return;
  const panel = panelOf(drawer);
  if (!panel) return;
  drawer.__mlkfrtsBack = true;
  panel.addEventListener('close', (event) => {
    if (event.target !== panel) return;
    // Normal close path removes [open] before closing the dialog, and mode
    // switches reopen it immediately, so this only fires for native closes.
    if (drawer.hasAttribute('open') && !panel.open && typeof drawer.close === 'function') {
      drawer.close();
    }
  });
}

function releaseStaleLocks() {
  document.querySelectorAll('theme-drawer').forEach((drawer) => {
    const panel = panelOf(drawer);
    if (!panel) return;
    if (drawer.hasAttribute('open') && !panel.open && typeof drawer.close === 'function') {
      drawer.close();
    } else if (!drawer.hasAttribute('open')) {
      unlockScroll(panel);
    }
  });
  document.querySelectorAll('dialog:not([open]), details[scroll-lock]:not([open])').forEach((el) => unlockScroll(el));
}

customElements.whenDefined('theme-drawer').then(() => {
  document.querySelectorAll('theme-drawer').forEach(wire);
  new MutationObserver(() => document.querySelectorAll('theme-drawer').forEach(wire)).observe(document.body, {
    childList: true,
    subtree: true,
  });
});

window.addEventListener('popstate', () => setTimeout(releaseStaleLocks, 50));
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  // Narrow screens: the drawer is a full-screen modal; start closed after Back/Forward.
  if (window.matchMedia('(max-width: 989px)').matches) {
    document.querySelectorAll('theme-drawer[open]').forEach((drawer) => {
      if (typeof drawer.close === 'function') drawer.close();
    });
  }
  setTimeout(releaseStaleLocks, 50);
});

window.__mlkfrtsDrawerBack = true;
